module.exports = __webpack_public_path__ + "img/Mstorybg202.64375b64.png";